// Navigation list with highlight like: http://html.dp.i-g.pl/test/views/modules/FormContact.html

export function getHighlightValues(currentNavElement: HTMLButtonElement|HTMLAnchorElement) {
    const width = currentNavElement.offsetWidth;
    const leftCorner = currentNavElement.offsetLeft;

    return {
        transform: `matrix(${width/100}, 0, 0, 1, ${leftCorner}, 0)`,
        width,
        leftCorner
    };
}

/**
 * Return number needed to scroll if button (leftCorner and width) is outside navList visible space.
 * It takes navList padding into account.
 * @param width
 * @param leftCorner
 * @param navList
 */
export function checkScrollPosition(width: number, leftCorner: number, navList: HTMLElement) {
    // Right corner of active button
    const rightCorner = leftCorner + width;
    const viewWidth = navList.offsetWidth;
    const leftScroll = navList.scrollLeft;
    const visiblePart = leftScroll + viewWidth;

    let scrollLeft = leftScroll;
    // hidden on the left or left side is hidden on the left
    if (rightCorner < leftScroll || leftCorner < leftScroll) {
        const style = window.getComputedStyle(navList);
        scrollLeft = leftCorner - parseInt(style.paddingLeft);
    }
    // right side is out of vsible part or it's hidden on the right
    else if (rightCorner > visiblePart || leftCorner > visiblePart) {
        const style = window.getComputedStyle(navList);
        scrollLeft = rightCorner - viewWidth + parseInt(style.paddingRight);
    }
    // return scroll postion to move or false so it stays as it is
    return scrollLeft !== leftScroll ? scrollLeft : false;
}
